import { z } from 'zod';

export enum BillingCycle {
  MONTHLY = 'monthly',
  ANNUAL = 'annual',
}

export const createLiberalCheckoutSchema = z.object({
  billing_cycle: z.enum(BillingCycle),
});

export type CreateLiberalCheckoutPayload = z.infer<typeof createLiberalCheckoutSchema>;

export interface LiberalCheckoutResponse {
  checkout_url: string;
}

export interface LiberalPortalResponse {
  portal_url: string;
}
